import { fg } from '@atlassian/jira-feature-gating';

const JsmEnableActionMenuAddPeopleSpotlightIdRelayProvider = {
	get(): boolean {
		return fg('jsm_enable_action-menu-add-people-spotlight-id');
	},
};

export default JsmEnableActionMenuAddPeopleSpotlightIdRelayProvider;
